import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints, siteMaxWidth }: Theme) => ({
  root: {
    marginBottom: '2rem',
    [breakpoints.up('sm')]: {
      marginBottom: '4rem',
    },
    '& > a': {
      maxWidth: siteMaxWidth,
      margin: '0 auto',
    },
  },
}));
